import { render, staticRenderFns } from "./ExhibitionSvgActive.vue?vue&type=template&id=6f9f7fd0&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports